const isLocalHost =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);

const shouldLogSync = import.meta.env.DEV || isLocalHost;

export const syncLog = (...args: unknown[]) => {
  if (shouldLogSync) {
    console.log(...args);
  }
};

export const syncError = (...args: unknown[]) => {
  if (shouldLogSync) {
    console.error(...args);
  }
};
